import React from 'react';
import type { LinkedTask } from '../../types/worklog';

// 「这页 wiki 讲的是哪条任务」。结构照抄 components/worklog/LinkedTasks.tsx——
// 同一个数据形状（WikiPagePresenter#linked_tasks_json 与 TaskPresenter 的
// linked_worklogs_json 输出的 task 字段完全一致，都是照 LinkedTask 类型写的），
// 换一套配色跟 wiki 页面本身（todo-* token）保持一致。
//
// 没有关联时整块不渲染，照 worklog 那侧的先例：wiki 页面写完可以一直改，
// 但「有没有关联到任务」不是每页都该有的状态，给每页都留一句「暂无」是噪音。

type LinkedTasksProps = {
  tasks: LinkedTask[];
};

const LinkedTasks: React.FC<LinkedTasksProps> = ({ tasks }) => {
  if (tasks.length === 0) return null;

  return (
    <div className="mb-[9px]">
      <div className="mb-[7px] flex items-baseline gap-[7px] px-0.5">
        <span className="text-[12.5px] font-semibold">关联的任务</span>
        <span className="rounded-full border border-todo-line bg-todo-card px-1.5 py-px font-mono text-[11px] text-todo-muted">
          {tasks.length}
        </span>
      </div>

      {tasks.map((task) => (
        <a
          key={task.id}
          href={`/todo/${task.url_key}`}
          className="mb-[7px] flex items-start gap-2 rounded-lg border border-todo-line bg-todo-card px-[10px] py-2 no-underline last:mb-0 hover:border-todo-line2"
        >
          {/* 只读勾选框，与 worklog/LinkedTasks.tsx 同一个理由：这里展示的是
              「当前完成状态」，不是入口——要勾去任务那边勾。 */}
          <span
            aria-hidden
            className={`mt-0.5 flex h-3.5 w-3.5 flex-none items-center justify-center rounded border text-[10px] font-bold leading-none ${
              task.completed
                ? 'border-todo-accent bg-todo-accent text-white'
                : 'border-todo-line2 bg-todo-card'
            }`}
          >
            {task.completed ? '✓' : ''}
          </span>
          <span className="min-w-0 flex-1">
            <span
              className={`block text-[12.5px] leading-snug ${
                task.completed ? 'text-todo-muted line-through' : 'text-todo-ink'
              }`}
            >
              {task.title}
            </span>
          </span>
          {task.linked_by === 'agent' && (
            <span className="text-[11px] text-todo-accent" title="AI 关联">
              ✦
            </span>
          )}
        </a>
      ))}
    </div>
  );
};

export default LinkedTasks;
